import { jsx as _jsx } from "react/jsx-runtime";
import { Blobs } from './blob/Blobs';
import { BlobConfig } from './blob/BlobConfig';
import { getColorTheme } from './blob/blobUtils';
export const BlobMessaging = ({
  blobKey,
  renderComponent,
  renderBleed,
  messageKey,
  colorThemeOption
}) => {
  const blobConfig = BlobConfig[blobKey];
  const {
    configColorThemeOption
  } = blobConfig;
  const colorTheme = colorThemeOption || configColorThemeOption;
  return /*#__PURE__*/_jsx(Blobs, {
    colorTheme: getColorTheme(colorTheme),
    messageKey: messageKey,
    renderBleed: renderBleed,
    children: renderComponent()
  });
};